
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/se-friendly/psychiatrists",
      function () {
        return require("private-next-pages/se-friendly/psychiatrists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/se-friendly/psychiatrists"])
      });
    }
  